import { HealthCenter } from '@silbo/core';
import { queryOptions } from '@tanstack/react-query';
import { getOpenCleaningMissionsQuery } from './get-open-cleaning-missions-query';

export const getOpenCleaningMissionsQueryOptions = (healthCenter: HealthCenter) =>
  queryOptions({
    queryKey: [
      getOpenCleaningMissionsQuery(healthCenter).className,
      getOpenCleaningMissionsQuery(healthCenter).toJSON(),
    ],
    queryFn: () => getOpenCleaningMissionsQuery(healthCenter).find(),
    refetchOnWindowFocus: 'always',
    refetchOnReconnect: 'always',
  });
